import { GridColDef } from "@mui/x-data-grid";
import { TextFilterOperator } from "components/shared/filters";

import { MutableRefObject, useEffect, useState } from "react";

import { GridApi, GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid-pro";
import CheckboxColumn from "./CheckboxColumn";
import { IWorkItemStatuses, IWorkItemStatusValidTransitions } from "hooks/work-items/useWorkItemPossibleStatus";
import { MenuItem, Select, Tooltip } from "@mui/material";
import { useFeatureEnabled } from "hooks/shared";

const WorkItemStatusOptions = (params: any, WorkItemStatuses: IWorkItemStatuses[], WorkItemStatusValidTransitions: IWorkItemStatusValidTransitions[]): { value: number, label: string }[] => {
  const row = params.row; // Extracting row from params if needed
  const currentStatus = WorkItemStatuses.find(status => status.value === row.workItemStatusId);
  if (currentStatus) {
    const result = [{ value: currentStatus?.value, label: currentStatus?.label }];
    const allStatusAllowed = WorkItemStatusValidTransitions.filter(transition => transition.fromStatus === currentStatus.value);

    if (allStatusAllowed.length) {
      allStatusAllowed.forEach(allowedStatus => {
        const transition = WorkItemStatuses.find(status => status.value === allowedStatus.toStatus);
        if (transition) {
          result.push(transition);
        }
      });
    }
    return result;
  }
  else {
    return WorkItemStatuses
  }
}


const useWorkItemColumns = (onChange: (changeType: string, params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>, event: any) => void,
  apiRef: MutableRefObject<GridApi>, WorkItemStatuses: IWorkItemStatuses[], WorkItemStatusValidTransitions: IWorkItemStatusValidTransitions[], WorkItemPermissions: any) => {
  const [wave4Enabled] = useFeatureEnabled('wave-4');
  const columnBase: GridColDef[] = [
    CheckboxColumn(apiRef),
    {
      field: 'workItemInstanceName',
      headerName: 'Work Item Name',
      flex: 1,
      minWidth: 200,
      sortable: true,
      resizable: true,
      hideable: false,
      headerClassName: 'header',
      hideSortIcons: false,
      disableReorder: true,
      filterOperators: TextFilterOperator,
      renderCell: (params) => {
        const name = params.row.workItemInstanceName;
        const workItemId = params.row.workItemInstanceId;
        const workItemUrl = process.env.REACT_APP_PUBLIC_URL + `/workitems/${workItemId}/overview`;
        return (
          <Tooltip title={name} arrow>
            <div>
              <a href={workItemUrl}
                style={{ color: '#0066CC', cursor: 'pointer', textDecoration: 'underline' }}
                rel="noopener noreferrer">
                {name}
              </a>
            </div>
          </Tooltip>
        );
      }
    },
    {
      field: 'workspaceInstanceName',
      headerName: 'Workspace',
      width: 200,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false
    },
    {
      field: 'contentTypeName',
      headerName: 'Content type',
      width: 200,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false
    },
    {
      field: 'workItemStatusId',
      headerName: 'Status',
      width: 200,
      sortable: false,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: true,
      renderCell: (params) => {
        var options = WorkItemStatusOptions(params, WorkItemStatuses, WorkItemStatusValidTransitions);
        if (options === undefined || options.length === 0) {
          return (<></>);
        }
        return (
          <Select value={params.row.workItemStatusId}
            style={{ width: '100%' }}
            onChange={(event) => onChange('status', params, event)}>
            {
              options.map((option: any) => (
                <MenuItem
                  key={option.value}
                  value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
          </Select>
        )
      }
    }
  ];

  const [columns, setColumns] = useState<GridColDef[]>(columnBase);

  useEffect(() => {
    let newColumns: GridColDef[] = [];
    newColumns.push(...columnBase);
    setColumns(newColumns);
  }, [WorkItemStatuses, WorkItemStatusValidTransitions]);

  return columns;
};

export default useWorkItemColumns;